module.exports = __webpack_public_path__ + "static/media/no_auth_pc@2x.ff13e7e1.png";